import { Stack } from '@mui/joy';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Card } from 'src/components';
import { useBiometrics, useDashStore } from 'src/hooks';
import Profile from 'src/routes/Profile/Profile';
import { getBioKey, Loading } from '../helpers';
import {
  AvgWalkingHRChart,
  HeartRateChart,
  HRVariabilityChart,
  OxygenSaturationChart,
  RespiratoryRateChart,
  RestingHRChart,
  SleepChart,
  StepCountChart,
} from './charts';

const Container = styled(Stack)(({ theme }) => ({
  width: '100%',
  height: 'calc(100vh - 100px)',
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
  gap: 3,
}));

const biometricChartMap = {
  HeartRate: HeartRateChart,
  RestingHeartRate: RestingHRChart,
  HeartRateVariability: HRVariabilityChart,
  AverageWalkingHeartRate: AvgWalkingHRChart,
  StepCount: StepCountChart,
  RespiratoryRate: RespiratoryRateChart,
  // 'BloodPressureDiastolic',
  // 'BloodPressureSystolic',
  OxygenSaturation: OxygenSaturationChart,
  Sleep: SleepChart,
};

export const BiometricsChart = (props) => {
  const { selectedUser, appUsers, viewingProfile } = useDashStore();
  const { selectedBio, getBiometricsForUser, ...biometricsData } = useBiometrics();

  const Chart = biometricChartMap[selectedBio];

  const biometricsKey = getBioKey(selectedBio) + 'All';
  const loadingKey = getBioKey(selectedBio) + 'Loading';

  return (
    <Card sx={{ marginTop: '20px', height: 'calc(100vh - 285px)' }}>
      {!appUsers.length ? (
        <Container>
          <Typography variant="instructions" style={{ fontSize: '24px' }}>
            No Users
          </Typography>
        </Container>
      ) : biometricsData[loadingKey] ? (
        <Loading />
      ) : biometricsData[biometricsKey].length ? (
        viewingProfile ? (
          <Profile />
        ) : (
          <Chart data={getBiometricsForUser(selectedBio, selectedUser)} />
        )
      ) : (
        <Container>
          <Typography variant="instructions" style={{ fontSize: '24px' }}>
            No Data
          </Typography>
        </Container>
      )}
    </Card>
  );
};
